"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var slate_react_1 = require("slate-react");
var objectUtilities_1 = require("../../../util/objectUtilities");
var Typography_1 = require("../../atoms/Typography/Typography");
var Editor_logic_1 = require("./Editor.logic");
var Editor_static_1 = require("./Editor.static");
var EditorFooter_1 = __importDefault(require("./EditorFooter/EditorFooter"));
var EditorLink_1 = __importDefault(require("./EditorLink/EditorLink"));
var EditorToolbar_1 = __importDefault(require("./EditorToolbar/EditorToolbar"));
/**
 * Editor organism
 *
 * {@link https://stories.data.bmw.cloud//?path=/story/organisms-editor-editor--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/organisms/Editor Source}
 */
var Editor = function (_a) {
    var className = _a.className, initialState = _a.initialState, maxHeight = _a.maxHeight, onDiscard = _a.onDiscard, onSave = _a.onSave, readOnly = _a.readOnly, saving = _a.saving, setEditorRef = _a.setEditorRef;
    var _b = (0, Editor_logic_1.useEditor)(initialState), classes = _b.classes, editor = _b.editor, editorKey = _b.editorKey, setEditorKey = _b.setEditorKey, setState = _b.setState, state = _b.state;
    var renderLeaf = (0, react_1.useCallback)(function (_a) {
        var attributes = _a.attributes, children = _a.children, leaf = _a.leaf;
        (0, objectUtilities_1.keys)(Editor_static_1.markHtmlElements).forEach(function (markType) {
            if (leaf[markType]) {
                var HtmlElement = Editor_static_1.markHtmlElements[markType];
                children = (0, jsx_runtime_1.jsx)(HtmlElement, { children: children });
            }
        });
        return (0, jsx_runtime_1.jsx)("span", __assign({}, attributes, { children: children }));
    }, []);
    var renderElement = (0, react_1.useCallback)(function (_a) {
        var attributes = _a.attributes, children = _a.children, element = _a.element;
        var type = element.type;
        // Due to: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
        var InlineFix = function () { return ((0, jsx_runtime_1.jsx)("span", __assign({ contentEditable: false, style: { fontSize: 0 } }, { children: String.fromCodePoint(160) }))); };
        var renderParagraph = function () {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": 'editor-paragraph' }, attributes, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, { children: children }) })));
        };
        switch (type) {
            case Editor_static_1.ElementType.ListItem:
                return (0, jsx_runtime_1.jsx)("li", __assign({}, attributes, { children: children }));
            case Editor_static_1.ElementType.NumberedList:
                return (0, jsx_runtime_1.jsx)("ol", __assign({}, attributes, { children: children }));
            case Editor_static_1.ElementType.BulletedList:
                return (0, jsx_runtime_1.jsx)("ul", __assign({}, attributes, { children: children }));
            case Editor_static_1.ElementType.Link:
                return ((0, jsx_runtime_1.jsxs)(EditorLink_1.default, __assign({ url: element.url, readOnly: !!readOnly, attributes: attributes }, { children: [(0, jsx_runtime_1.jsx)(InlineFix, {}), children, (0, jsx_runtime_1.jsx)(InlineFix, {})] })));
            case undefined:
            case Editor_static_1.ElementType.Paragraph:
                return renderParagraph();
            case Editor_static_1.ElementType.Headline:
                return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": 'editor-headline' }, attributes, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'body2' }, { children: children })) })));
            case Editor_static_1.ElementType.SubHeadline:
                return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": 'editor-sub-headline' }, attributes, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ bold: true }, { children: children })) })));
            default:
                // The input may contain invalid types that should not crash the
                // app but be ignored (i.e., rendered as a regular paragraph).
                // An exhaustiveness check is desired nonetheless.
                try {
                    return (0, objectUtilities_1.exhaustivenessCheck)(type);
                }
                catch (_b) {
                    return renderParagraph();
                }
        }
    }, [readOnly]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(className, !readOnly && classes.root), style: readOnly ? undefined : { maxHeight: maxHeight } }, { children: (0, jsx_runtime_1.jsxs)(slate_react_1.Slate, __assign({ editor: editor, value: state, onChange: setState }, { children: [!readOnly && (0, jsx_runtime_1.jsx)(EditorToolbar_1.default, {}), (0, jsx_runtime_1.jsx)(slate_react_1.Editable, { className: (0, classnames_1.default)(classes.lists, !readOnly && classes.editable), onBlur: editor.onBlur, onKeyDown: editor.onKeyDown, onKeyUp: editor.onKeyUp, readOnly: readOnly, renderElement: renderElement, renderLeaf: renderLeaf }), !readOnly && ((0, jsx_runtime_1.jsx)(EditorFooter_1.default, { setEditorRef: setEditorRef, initialState: initialState, onDiscard: onDiscard, onSave: onSave, saving: saving, setEditorKey: setEditorKey, setState: setState, state: state }))] }), editorKey) })));
};
exports.Editor = Editor;
